import React from "react";
import "./Shapes.scss";

export const TitleBar = () => {
  return (
    <div className="title-bar">
      <hr className="left-line"/>
      <div className="title-bar-diamond"></div>
      <hr className="right-line"/>
    </div>
  );
};

export const ProcessStart = () => {
  return (
    <div className="process-start">
      <div className="circle"></div>
      <hr />
    </div>
  );
};

export const ProcessMiddle = () => {
  return (
    <div className="process-middle">
      <div className="circle"></div>
      <hr />
    </div>
  );
};

export const ProcessEnd = () => {
  return (
    <div className="process-end">
      <div className="circle"></div>
      <hr />
    </div>
  );
};
